import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromAppLegal } from "../inject";
import type { ICookieSettingsStore } from "../../shared-components/cookie-banner/CookieSettingsStore";
import { CookiePolicyIT } from "./CookiePolicyIT";
import { CookiePolicyDE } from "./CookiePolicyDE";
import { CookiePolicyES } from "./CookiePolicyES";
import { CookiePolicyFR } from "./CookiePolicyFR";
import { CookiePolicyNL } from "./CookiePolicyNL";
import { CookiePolicyPTBR } from "./CookiePolicyPTBR";
import { CookiePolicyEN } from "./CookiePolicyEN";
import { CookiePolicyNO } from "./CookiePolicyNO";

interface ICookiePolicyComponentProps {
    resourcesStore?: IResourcesStore;
    cookieSettingsStore?: ICookieSettingsStore;
}

interface ICookiePolicyComponentState {
    active: boolean;
}

@injectFromAppLegal<ICookiePolicyComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
    cookieSettingsStore: stores.cookieSettingsStore,
}))

@observer
export class CookiePolicyComponent extends React.Component<ICookiePolicyComponentProps, ICookiePolicyComponentState> {
    state = {
        active: false,
    };

    toggleActive = (event): void => {
        this.setState((oldState) => ({
            active: !oldState.active,
        }));
    };

    showCookieBanner = (event): void => {
        const { cookieSettingsStore } = this.props;
        cookieSettingsStore!.show();
    };

    render() {
        const { resourcesStore } = this.props;
        const { currentLanguage, resources } = resourcesStore!;

        let translatedCookiePolicy;

        switch (currentLanguage) {
            case "nl":
                translatedCookiePolicy = <CookiePolicyNL />;
                break;
            case "fr":
                translatedCookiePolicy = <CookiePolicyFR />;
                break;
            case "de":
                translatedCookiePolicy = <CookiePolicyDE />;
                break;
            case "pt-br":
                translatedCookiePolicy = <CookiePolicyPTBR />;
                break;
            case "es":
                translatedCookiePolicy = <CookiePolicyES />;
                break;
            case "it":
                translatedCookiePolicy = <CookiePolicyIT />;
                break;
            case "no":
                translatedCookiePolicy = <CookiePolicyNO />;
                break;
            case "en":
            default:
                translatedCookiePolicy = <CookiePolicyEN />;
                break;
        }

        return (
            <div className={"legal-partial-container" + (this.state.active ? " active" : "")}>
                <h2 onClick={this.toggleActive}>{resources.CookiePolicy}</h2>
                <div className={"content"}>
                    <button className={"blue"} onClick={this.showCookieBanner}>
                        {resources.ChangeCookieSettings}
                    </button>
                    <br />
                    <br />
                    {translatedCookiePolicy}
                </div>
            </div>
        );
    }
}
